import React from 'react';
import { authSelector, buyerIsForeign } from '@src/features/auth';
import { MdOutlineEmail, MdOutlinePersonOutline, MdOutlinePhone } from 'react-icons/md';
import { useAppSelector } from '@src/core/hooks';
import { Box, Email, Icon, Identity, Name, Phone, Value } from './styles';
import { BRAZIL_PHONE_DDI } from '@src/features/order';
import { applyIdentityMask, applyMask } from '@src/common/masks';

const UserContactInfo = () => {
  const { buyer } = useAppSelector(authSelector);
  const isForeignBuyer = useAppSelector(buyerIsForeign);

  const getMaskedPhone = (phone: string) => {
    if (phone.startsWith(BRAZIL_PHONE_DDI)) {
      return applyMask(phone, 'brazilian_phone');
    }

    return phone;
  };

  const getMaskedIdentity = (identity: string) => (isForeignBuyer ? buyer!.identity : applyIdentityMask(identity));

  return (
    <Box>
      <Name>{buyer!.fullName}</Name>
      {buyer!.email ? (
        <Email>
          <Icon>
            <MdOutlineEmail size={16} />
          </Icon>
          <Value>{buyer!.email}</Value>
        </Email>
      ) : null}

      {buyer!.phone ? (
        <Phone>
          <MdOutlinePhone size={16} /> {getMaskedPhone(buyer!.phone)}
        </Phone>
      ) : null}

      {buyer!.identity ? (
        <Identity>
          <MdOutlinePersonOutline size={16} /> {getMaskedIdentity(buyer!.identity)}
        </Identity>
      ) : null}
    </Box>
  );
};

export default UserContactInfo;
